import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Particle {
  id: string;
  x: number;
  y: number;
  size: number;
  color: string;
  speedX: number;
  speedY: number;
}
const COLORS = ['#faff31', '#15c8ff', '#4f0c9a']; // Yellow, bright blue, purple
export const TetrisBackground: React.FC = () => {
  const [particles, setParticles] = useState<Particle[]>([]);
  useEffect(() => {
    const createParticle = (): Particle => ({
      id: Math.random().toString(36).substr(2, 9),
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 2,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      speedX: (Math.random() - 0.5) * 0.3,
      speedY: (Math.random() - 0.5) * 0.3
    });
    // Create initial particles
    const initialParticles = Array.from({
      length: 40
    }, createParticle);
    setParticles(initialParticles);
  }, []);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-369">
      {/* Floating particles */}
      {particles.map(particle => <motion.div key={particle.id} className="absolute rounded-full" style={{
      width: particle.size,
      height: particle.size,
      backgroundColor: particle.color,
      boxShadow: `0 0 ${particle.size * 3}px ${particle.color}`
    }} initial={{
      x: `${particle.x}%`,
      y: `${particle.y}%`,
      opacity: 0
    }} animate={{
      x: [`${particle.x}%`, `${particle.x + particle.speedX * 20}%`, `${particle.x}%`],
      y: [`${particle.y}%`, `${particle.y + particle.speedY * 20}%`, `${particle.y}%`],
      opacity: [0, 0.4, 0.6, 0.4, 0],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: Math.random() * 15 + 10,
      repeat: Infinity,
      ease: 'easeInOut',
      times: [0, 0.25, 0.5, 0.75, 1]
    }} data-id="element-370" />)}

      {/* Subtle wave lines */}
      <svg className="absolute inset-0 w-full h-full opacity-10" data-id="element-371">
        <defs data-id="element-372">
          <linearGradient id="waveGradient1" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-373">
            <stop offset="0%" stopColor="#faff31" stopOpacity="0" data-id="element-374" />
            <stop offset="50%" stopColor="#faff31" stopOpacity="0.3" data-id="element-375" />
            <stop offset="100%" stopColor="#faff31" stopOpacity="0" data-id="element-376" />
          </linearGradient>
          <linearGradient id="waveGradient2" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-377">
            <stop offset="0%" stopColor="#15c8ff" stopOpacity="0" data-id="element-378" />
            <stop offset="50%" stopColor="#15c8ff" stopOpacity="0.3" data-id="element-379" />
            <stop offset="100%" stopColor="#15c8ff" stopOpacity="0" data-id="element-380" />
          </linearGradient>
        </defs>

        <motion.path d="M0,300 Q400,250 800,300 T1600,300" stroke="url(#waveGradient1)" strokeWidth="2" fill="none" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: [0.3, 0.6, 0.3],
        translateX: [0, 100, 0]
      }} transition={{
        pathLength: {
          duration: 3
        },
        opacity: {
          duration: 4,
          repeat: Infinity
        },
        translateX: {
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }
      }} data-id="element-381" />

        <motion.path d="M0,500 Q400,550 800,500 T1600,500" stroke="url(#waveGradient2)" strokeWidth="2" fill="none" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: [0.3, 0.6, 0.3],
        translateX: [0, -100, 0]
      }} transition={{
        pathLength: {
          duration: 3,
          delay: 0.5
        },
        opacity: {
          duration: 5,
          repeat: Infinity,
          delay: 1
        },
        translateX: {
          duration: 25,
          repeat: Infinity,
          ease: 'linear'
        }
      }} data-id="element-382" />
      </svg>

      {/* Radial pulse effect */}
      <motion.div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full" style={{
      background: 'radial-gradient(circle, rgba(21, 200, 255, 0.1) 0%, transparent 70%)'
    }} animate={{
      scale: [1, 1.2, 1],
      opacity: [0.3, 0.5, 0.3]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-383" />
    </div>;
};